// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITradingAmountsDto
 */
export interface ITradingAmountsDto {
    /**
     * 
     * @type {number}
     * @memberof ITradingAmountsDto
     */
    deposit_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ITradingAmountsDto
     */
    withdrawal_amount?: number;
}

/**
 * Check if a given object implements the ITradingAmountsDto interface.
 */
export function instanceOfITradingAmountsDto(value: object): value is ITradingAmountsDto {
    return true;
}

export function ITradingAmountsDtoFromJSON(json: any): ITradingAmountsDto {
    return ITradingAmountsDtoFromJSONTyped(json, false);
}

export function ITradingAmountsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITradingAmountsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'deposit_amount': json['deposit_amount'] == null ? undefined : json['deposit_amount'],
        'withdrawal_amount': json['withdrawal_amount'] == null ? undefined : json['withdrawal_amount'],
    };
}

export function ITradingAmountsDtoToJSON(json: any): ITradingAmountsDto {
    return ITradingAmountsDtoToJSONTyped(json, false);
}

export function ITradingAmountsDtoToJSONTyped(value?: ITradingAmountsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deposit_amount': value['deposit_amount'],
        'withdrawal_amount': value['withdrawal_amount'],
    };
}

